import React, { Fragment } from 'react'

import DeleteConfirmationModal from 'Pods/Profile/Settings/DeleteAccountButton/DeleteConfirmationModal'

class DeleteModalButton extends React.Component {
  constructor() {
    super()

    this.state = { deleteConfirmationModalIsOpen: false }
    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal(e) {
    e.preventDefault();

    this.setState(prevState => ({
      deleteConfirmationModalIsOpen: !prevState.deleteConfirmationModalIsOpen,
    }))
  }

  render() {
    return (
      <Fragment>
        <button className="cgt-button cgt-button--secondary cgt-button--large cgt-mr-10" onClick={(e) => this.toggleModal(e) }>
          <span>Delete Account</span>
        </button>
        {this.state.deleteConfirmationModalIsOpen && (
          <DeleteConfirmationModal
            modalIsOpen
            closeModal={this.toggleModal}
          />
        )}
      </Fragment>
    )
  }
}

export default DeleteModalButton
